import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const ExternalInfinityExtensionIframe = loadAsyncComponent(
  () => import(/* webpackChunkName: "ExternalInfinityExtensionIframe" */ './Container'),
  'page'
);
